module.exports = __webpack_public_path__ + "img/1440.36a9357d.jpg";